import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@purpose/ui/components/accordion/accordion';

type FilterSectionAccordionProps = {
  title: string;
  children: React.ReactNode;
  isActive?: boolean;
};

type DropdownProps = {
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

const Dropdown = ({header, children, className}: DropdownProps) => {
  return (
    <Accordion
      type="single"
      collapsible
      className={`w-full ${className || ''}`}
    >
      <AccordionItem value="item-1" className="border-none">
        <AccordionTrigger className="flex items-center justify-between p-0 hover:no-underline">
          <div className="mr-4 flex w-full flex-row items-center justify-between">
            {header}
          </div>
        </AccordionTrigger>
        <AccordionContent className="pt-2">{children}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

const FilterSectionAccordion = ({
  title,
  children,
  isActive = false
}: FilterSectionAccordionProps) => {
  return (
    <Dropdown
      header={
        <div className="flex w-full items-center justify-between gap-2">
          <span className="text-lg font-semibold">{title}</span>
          {isActive && (
            <div className="h-[12px] w-[12px] rounded-full bg-[#48578B]" />
          )}
        </div>
      }
    >
      {children}
    </Dropdown>
  );
};

export default FilterSectionAccordion;
